import moment from 'moment';

const get = (key) => {
  try {
    const serializedData = localStorage.getItem(key);

    if (serializedData === null) {
      return undefined;
    }

    const data = JSON.parse(serializedData);

    if (data.expiry && data.expiry <= moment.now()) {
      localStorage.removeItem(key);
      return undefined;
    }

    return data.value;
  } catch (err) {
    return undefined;
  }
};

const save = (key, value, expiry) => {
  if (expiry && expiry <= moment.now()) {
    return;
  }

  try {
    const storageData = JSON.stringify({ value, expiry });

    localStorage.setItem(key, storageData);
  } catch (err) {
    return;
  }
};

const storage = { get, save };

export default storage;



/** WEBPACK FOOTER **
 ** ./src/common/LocalStorage.js
 **/